import type { FaireProductEntity } from "../../entity_types/product";

export const p_40k58l5r: FaireProductEntity = {
  token: "p_40k58l5r",
  type: "product",
  name: "Hug Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/e9498b5fe8ebee37b9fe935ecfa131f2d38b9c364a4ad8739a7e4a3f4a63b9ba/1528357685.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d961197ddcc9685f2ab5daed62a2039920576080cd6918f7826764e41b00c2f7/1528357685.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:20.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
